export class MixerLogoDeleteCmd {}
